import React, { Fragment } from "react";
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap";

const ModalDeleteStaff = ({ name, axiosDelete, pk, resetState, toggle, isOpen }) => {

  const deleteItem = async () => {
    axiosDelete.deleteStaf(pk).then(() => {
      resetState();
    });
  };

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={() => toggle()}>
        <ModalHeader>Apakah Anda yakin untuk menghapus {name}?</ModalHeader>

        <ModalFooter>
          <Button color="primary" type="button" onClick={() => toggle()}>
            Batal
          </Button>
          <Button
            type="button"
            color="danger"
            onClick={() => {
              toggle();
              deleteItem();
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default ModalDeleteStaff;
